import { ParameterEntity } from "domain/entity/Parameter/ParameterEntity";
import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { axiosDeleteData, axiosGetData, axiosPostData, axiosPutData } from "../axios/AxiosBasicImpl";
import referenceAxiosInstance from "../axios/referenceAxiosInstance";
import { ParameterRepository } from "./ParameterRepo";
import { ParameterSearchCriteria } from "domain/entity/Parameter/ParameterSearchCriteria";

/**
 * For template
 * @returns 
 */
export const ParameterRepoImpl = (): ParameterRepository => {
    const url = '/v1/parameter';

    const getEntities = async (): Promise<ParameterEntity[]> => {
        return await axiosGetData(referenceAxiosInstance, url, []).then(res => {
            return res.data
        }).catch(err => {
            return [];
        });

    }

    const getEntityByKey = async (key: string): Promise<ParameterEntity> => {
        return await axiosGetData(referenceAxiosInstance, `${url}/${key}`, []).then(res => {
            return res.data;
        }).catch(err => {
            return null;
        });
    }

    const searchParamBySearchCriteria = async (paramSearchCriteria: ParameterSearchCriteria): Promise<ParameterEntity> => {
        let newUrl = '/v1/parameter/parameterSearch';

        return axiosPostData(referenceAxiosInstance, `${newUrl}`, paramSearchCriteria).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const createEntity = async (newData: ParameterEntity): Promise<ResponseEntity> => {
        return await axiosPostData(referenceAxiosInstance, `${url}`, newData);
    }

    const updateEntity = async (updatedData: ParameterEntity): Promise<ResponseEntity> => {
        return await axiosPutData(referenceAxiosInstance, `${url}`, updatedData);
    }

    const deleteEntity = async (key: string): Promise<ResponseEntity> => {
        return await axiosDeleteData(referenceAxiosInstance, `${url}`, key);
    }

    return {
        getEntities: getEntities,
        getEntityByKey: getEntityByKey,
        searchParamBySearchCriteria: searchParamBySearchCriteria,
        createEntity: createEntity,
        updateEntity: updateEntity,
        deleteEntity: deleteEntity,
    }
}